var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelLogoMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 5.66671C5.77329 5.66671 6.66663 4.77337 6.66663 3.66671C6.66663 2.56004 5.77329 1.66671 4.66663 1.66671C3.55996 1.66671 2.66663 2.56004 2.66663 3.66671C2.66663 4.77337 3.55996 5.66671 4.66663 5.66671ZM12.6666 1.66671H7.33329V6.33337H1.99996V0.333374H0.666626V10.3334H1.99996V8.33337H14V10.3334H15.3333V4.33337C15.3333 2.86004 14.14 1.66671 12.6666 1.66671Z",
    fill: "#DBBE78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelLogoMaps);
export default __webpack_public_path__ + "static/media/hotel-logo-maps.f9c978d38b588240fbd7840ac256d5ba.svg";
export { ForwardRef as ReactComponent };